import { Details } from '../components/Details';
import { useCurrentCampaign } from '../hooks/useCampaign';
import {
  CampaignLayout as SharedCampaignLayout,
  CampaignLayoutProps as SharedCampaignLayoutProps,
} from '@features/campaigns/components/CampaignLayout';

type CampaignLayoutProps = Omit<
  SharedCampaignLayoutProps,
  'campaignHook' | 'renderDetails'
>;

export const CampaignLayout = (props: CampaignLayoutProps) => {
  const campaignHook = useCurrentCampaign();

  return (
    <SharedCampaignLayout
      {...props}
      campaignHook={campaignHook}
      renderDetails={Details}
    />
  );
};
